import React from 'react';

import styles from './Scroller.m.sass';

export default class Scroller extends React.PureComponent {
  render() {
    const {children} = this.props;

    return (
      <div className={styles.scroller}>
        <div className={styles.scroller_wrapper}>
          {children}
        </div>

        <div className={styles.scroller_dots}>
          <div className={`${styles.scroller_dot} ${styles.scroller_dot__active}`}>
            <div className={styles.scroller_dotInner}/>
          </div>
          <div className={styles.scroller_dot}>
            <div className={styles.scroller_dotInner}/>
          </div>
          <div className={styles.scroller_dot}>
            <div className={styles.scroller_dotInner}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/scroller/Scroller.js